import * as z from "zod";

export const UserItemCountSchema = z.object({
  userName: z.string(),
  count: z.number(),
});

export type UserItemCount = z.infer<typeof UserItemCountSchema>;

export const getReturnsItemsByUser = {
  name: "getReturnsItemsByUser" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    merchantTeamId: z.string().optional(),
  }),
  output: z.object({ users: z.array(UserItemCountSchema) }),
};
